import { ChatCircleTextIcon } from '@phosphor-icons/react';
import { DrawerClose } from '@/components/ui/drawer';
import { useFeatureFlags } from '@/lib/telemetry';
import { PROBLEM_REPORT_FLAG, emitOpenProblemReport } from '@/lib/problemReport';

export function ProblemReportDrawerEntry() {
  const enabled = useFeatureFlags(PROBLEM_REPORT_FLAG);
  if (!enabled) return null;

  const handleReportProblem = () => emitOpenProblemReport('mobile-nav');

  // DrawerClose dismisses the bottom-nav drawer before the global dialog opens, so the dialog
  // isn't rendered behind the drawer overlay (same pattern the drawer's nav links use).
  return (
    <DrawerClose asChild>
      <button
        type="button"
        onClick={handleReportProblem}
        className="flex w-full cursor-pointer items-center gap-3 rounded-xl p-3 text-sm font-medium text-text-primary transition-colors hover:bg-neutral-100 active:bg-neutral-200"
      >
        <ChatCircleTextIcon size={20} weight="regular" className="text-text-secondary" />
        <span>Relatar um problema</span>
      </button>
    </DrawerClose>
  );
}
